import React from "react";

const SkeletonRow = () => (
  <div className="flex items-center gap-3 px-4 py-3 border-b border-slate-100 dark:border-slate-800 animate-pulse">
    <div className="w-10 h-10 rounded-full bg-slate-200 dark:bg-slate-700 flex-shrink-0" />
    <div className="flex-1 space-y-2">
      <div className="h-3 bg-slate-200 dark:bg-slate-700 rounded w-24" />
      <div className="h-3 bg-slate-200 dark:bg-slate-700 rounded w-36" />
    </div>
    <div className="h-3 bg-slate-200 dark:bg-slate-700 rounded w-10" />
  </div>
);

const TicketsListSkeleton = () => (
  <>
    <SkeletonRow />
    <SkeletonRow />
    <SkeletonRow />
  </>
);

export default TicketsListSkeleton;
